import { render, staticRenderFns } from "./RentalCompanyGroupAddButton.vue?vue&type=template&id=2569c2a4&scoped=true"
import script from "./RentalCompanyGroupAddButton.vue?vue&type=script&lang=js"
export * from "./RentalCompanyGroupAddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2569c2a4",
  null
  
)

export default component.exports